import { render, staticRenderFns } from "./Stockist.vue?vue&type=template&id=e1628472&scoped=true&"
import script from "./Stockist.vue?vue&type=script&lang=js&"
export * from "./Stockist.vue?vue&type=script&lang=js&"
import style0 from "./Stockist.vue?vue&type=style&index=0&id=e1628472&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1628472",
  null
  
)

export default component.exports